import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs3 = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    subtitle,
    image_gatsby,
    titleElement,
    paragraphElement,
    titleSecondary,
    subtitleColor,
    subtitleHexa,
    titleColor,
    titleHexa,
    alignCenter,
  } = props
  return (
    <section className="about-main c p-y-config banner-main">
      <Container fluid>
        <Row className="content-main d-flex align-items-center ">
          <Col xs={12}>
            <Row className={'pt-lg-0 ' + (alignCenter ? 'text-center' : '')}>
              <Col
                xs={{ span: 12, order: 2 }}
                lg={{ order: 1 }}
              >
                <ElementHTML
                  children={title || 'Nosotros'}
                  elementType={titleElement || 'h1'}
                  className={'mb-lg-4 section-name ' + titleColor}
                  style={{ color: titleHexa }}
                />
                <div className="mb-lg-5 mb-4">
                  {subtitle?.split('\n').map((paragraph_, index) => (
                    <ElementHTML
                      children={paragraph_ || ''}
                      key={index}
                      elementType={paragraphElement || 'h2'}
                      className={
                        'section-paragraph mb-0 ' +
                        (subtitleColor ? subtitleColor : titleSecondary ? 'text-secondary' : '')
                      }
                      style={{ color: subtitleHexa }}
                    />
                  ))}
                </div>
              </Col>
              {image_gatsby && (
                <Col xs={{ span: 12, order: 3 }}>
                  <Image
                    className="w-100 background-image-absolute"
                    objectFit="cover"
                    alt="about-us-img"
                    image={image_gatsby!}
                  />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs3
